var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"row-box"},[_c('WrapperField',{attrs:{"data":_vm.createDataField({
      fieldName: 'notarialWritName', 
      fieldValue: _vm.data.notarialWritName, 
      fieldGroup: 'executiveNoticesRecoveryDetails',
    })}}),_c('div',{staticClass:"form-base__title preview break"},[_vm._v("Сведения о договоре")]),_vm._l((_vm.data),function(value,index){return _c('WrapperField',{key:value + index + Math.random(),attrs:{"data":_vm.createDataField({
      fieldName: index, 
      fieldValue: value, 
      fieldGroup: 'executiveNoticesRecoveryDetails',
      fieldGroupEdit: 'noticesRecoveryStep5',
    })}})})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }